import core from './core';
import { Glossary } from '../helpers/Glossary';
import { ShippingHelper } from '../helpers/shipping';

const ShipmentTime = core.extend({
	constructor(options) {
		this.config = {
			applyShiftOfNonChristmasProducts: true,
			selectors: {
				productionNote: '.production-note',
				lastOrderDate: '.last-order-date',
				lastOrderTime: '.last-order-time',
				hourPlace: '.order-hours',
				minPlace: '.order-min',
				expressDay: '.express-delivery',
				standardDay: '.standard-delivery',
			},
			useIncreasedProductionDelayForBundleProducts: false,
		};

		this.$ = {};
		this.$.holder = jQuery(options.holder);
		this.loadObjects(options.holder);
		jQuery.extend(true, this.config, options || {});

		let timezoneOffsetString = `${Math.abs(this.config.data.cutoffTimezoneOffsetInHours)}:00`;

		if (Math.abs(this.config.data.cutoffTimezoneOffsetInHours) < 10) {
			timezoneOffsetString = `0${timezoneOffsetString}`;
		}
		if (this.config.data.cutoffTimezoneOffsetInHours >= 0) {
			timezoneOffsetString = `+${timezoneOffsetString}`;
		} else {
			timezoneOffsetString = `-${timezoneOffsetString}`;
		}
		this.config.timezoneOffsetString = timezoneOffsetString;

		this.init();
	},

	init() {
		const time = this.calcOrderTime();

		this.$.hourPlace.html(time.hours);
		this.$.minPlace.html(time.minutes);

		const orderDate = this.getOrderDate();
		const dayObject = this.getMeaningfulDay(orderDate);

		this.$.productionNote.html(this.getProductionMessage(this.config.prodOptions));
		this.$.lastOrderDate.html(dayObject.text);
		this.$.lastOrderTime.html(
			orderDate.toLocaleTimeString([], {
				hour: '2-digit',
				minute: '2-digit',
			})
		);

		this.calcShippingDay(this.config.prodOptions);
	},

	getProductionMessage(options) {
		if (this.config.showProductionNote === false) {
			return '';
		}
		if (this.hasLacquer(options)) {
			return 'Unsere Produkte mit Relieflack haben eine längere Produktionszeit als unveredelte Produkte. ';
		}
		if (this.hasRefinement(options)) {
			return 'Unsere Produkte mit Veredelung haben eine längere Produktionszeit als unveredelte Produkte. ';
		}
		if (this.isCalendar(options)) {
			return '';
		}
		if (this.hasDiecut(options)) {
			return 'Unsere Produkte mit Stanzung haben eine längere Produktionszeit. ';
		}

		return '';
	},

	hasRefinement(options) {
		return options.refinement && options.refinement !== Glossary.NO_REFINEMENT_SKU;
	},

	hasDiecut(options) {
		return options.diecut && options.diecut !== Glossary.NO_DIECUT_SKU;
	},

	hasLacquer(options) {
		return options.refinement && options.refinement === 'V01';
	},

	isCalendar(options) {
		const calendarFormatsRegEx = /F4\d{2}$/gi;

		return options.format && options.format.match(calendarFormatsRegEx);
	},

	/*
	 * calculating within how many hours can you order a product to receive it as fast as possible
	 *
	 * @method calcOrderTime
	 * @return {Object} hours and minutes
	 * */
	calcOrderTime() {
		let diffTime = this.getOrderTime(0, this.getCurrentDate());

		diffTime = diffTime / 1000 / 60;
		const minutes = diffTime % 60;
		const hours = diffTime / 60;

		return {
			hours: parseInt(hours),
			minutes: parseInt(minutes),
		};
	},

	/*
	 * calculation of order time which include checking holidays and weekends
	 * it checks current and next day of the order
	 *
	 * @method getOrderTime
	 * @param orderTime {Number} time in ms during which you can order a product and receive it in the fastest time
	 * @param day {Object} Date type object - day of ordering
	 * @return {Number} ordering time in ms
	 * */
	getOrderTime(orderTime, day) {
		const curDay = day || this.getCurrentDate();

		let nextDay;

		if (this.isHoliday(curDay, this.config.data.standard.productionHolidays)) {
			// if it is holiday take next day to calculate order time
			nextDay = this.getNextDay(curDay);

			return this.getOrderTime(orderTime + (nextDay.getTime() - curDay.getTime()), nextDay);
		}
		if (this.isWeekend(curDay)) {
			// if it is weekday take next day to calculate order time
			nextDay = this.getNextDay(curDay);

			return this.getOrderTime(orderTime + (nextDay.getTime() - curDay.getTime()), nextDay);
		}
		if (this.isBeforeCutoffTime(curDay)) {
			// if it is before cutoff time just send the time of ordering
			return orderTime + (this.getCutoffTime(curDay).getTime() - curDay.getTime());
		}
		// if it is after cutoff check next day
		nextDay = this.getNextDay(curDay);

		return this.getOrderTime(orderTime + (nextDay.getTime() - curDay.getTime()), nextDay);
	},

	/*
	 * @method getOrderDate
	 * @param day {Object} Date type object - day of ordering
	 * @return {Object} Date type object
	 * */
	getOrderDate(day) {
		const curDay = day || this.getCurrentDate();

		if (this.isHoliday(curDay, this.config.data.standard.productionHolidays)) {
			// if it is holiday take next day to calculate order time
			return this.getOrderDate(this.getNextDay(curDay));
		}

		if (this.isWeekend(curDay)) {
			// if it is weekday take next day to calculate order time
			return this.getOrderDate(this.getNextDay(curDay));
		}

		if (this.isBeforeCutoffTime(curDay)) {
			// if it is before cutoff time just send the time of ordering
			return this.getCutoffTime(curDay);
		}

		// if it is after cutoff check next day
		return this.getOrderDate(this.getNextDay(curDay));
	},

	/*
	 * calculating a day of shipment and setting it on the page
	 *
	 * @method calcShippingDay
	 * @param prodOptions {Object} set of options of product which could influence of production time
	 * */
	calcShippingDay(prodOption) {
		/*
		 * the product group is not always provided (e.g. when updating a basket item),
		 * so in order to make checks based on the product group, it is added from the
		 * initial data provided in the constructor
		 */
		if (!prodOption.category) {
			prodOption.category = this.config.prodOptions.category;
		}
		this.$.productionNote.html(this.getProductionMessage(prodOption));
		_.each(['standard', 'express'], (type) => {
			const dayObject = this.getShippingDay(type, prodOption);

			if (this.$.holder.attr(`data-prod-time-${type}`)) {
				if (dayObject.productionDays >= this.$.holder.attr(`data-prod-time-${type}`)) {
					this.$[`${type}Day`].html(dayObject.text);
					this.$.holder.attr(`data-prod-time-${type}`, dayObject.productionDays);
				}
			} else {
				this.$[`${type}Day`].html(dayObject.text);
			}
		});
	},

	/*
	 * @method getShippingDay
	 * @param type {String} shipment method - standard or express
	 * @param prodOptions {Object} set of options of product which could influence of production time
	 * @return {String} name of day of the week or 'today' or 'tomorrow' which will be shown on the page
	 * */
	getShippingDay(type, prodOptions) {
		const productionDays =
			this.getProductionTime(type, this.getCurrentDate()) + this.calcAdditionalProdDays(prodOptions);

		const baseDate = this.getBaseDateForNonChristmasProductsWithStandardShipping(type, prodOptions.category);
		const day = new Date(this.getDayOfShipment(type, productionDays, baseDate));

		return this.getMeaningfulDay(day, productionDays);
	},

	getBaseDateForNonChristmasProductsWithStandardShipping(type, productGroup) {
		const today = this.getCurrentDate();

		if (!this.config.applyShiftOfNonChristmasProducts) {
			return today;
		}
		if (type === 'express') {
			return today;
		}

		if (!ShippingHelper.productGroupCanBeShiftedToAfterChristmas(productGroup)) {
			return today;
		}

		const baseDateForNonChristmasProductsOrderedWithStandardShipping = new Date('2021-12-24');

		return type === 'standard'
			? new Date(Math.max.apply(null, [today, baseDateForNonChristmasProductsOrderedWithStandardShipping]))
			: today;
	},

	/*
	 * @method getMeaningfulDay
	 * @param date {Object} Date type object
	 * @param productionDays {Number}
	 * @return {String} name of day of the week or 'today' or 'tomorrow' which will be shown on the page
	 * */
	getMeaningfulDay(date, productionDays) {
		const day = new Date(date.getTime());
		const orderDay = new Date(this.config.data.currentDateTime); // day of order a product
		const orderDayDMY = `${orderDay.getDate()}-${orderDay.getMonth()}-${orderDay.getFullYear()}`; // day of order a product in dd-mm-yyyy format

		let productionTime = -1; // in order to use words 'today' or 'tomorrow' on the pag;

		// move timezone
		day.setUTCHours(day.getUTCHours() + this.config.data.cutoffTimezoneOffsetInHours);
		// day of week in format from 0 - 6 (sunday - saturday)
		const dayDMY = `${day.getUTCDate()}-${day.getUTCMonth()}-${day.getUTCFullYear()}`;
		const weekDayCode = day.getUTCDay();

		const afterOrderDay = new Date(orderDay.getTime());
		const oneWeekAfterOrderDay = new Date(orderDay.getTime());

		afterOrderDay.setDate(afterOrderDay.getDate() + 1);
		// next day of order a product in dd-mm-yyyy format
		const afterOrderDayDMY = `${afterOrderDay.getDate()}-${afterOrderDay.getMonth()}-${afterOrderDay.getFullYear()}`;

		oneWeekAfterOrderDay.setDate(oneWeekAfterOrderDay.getDate() + 7);
		oneWeekAfterOrderDay.setHours(0, 0, 0, 0);

		/*
		 * if product will be shipped today or tomorrow
		 * we will use words 'today'/'tomorrow' instead of names of week days
		 * */
		if (dayDMY === orderDayDMY) {
			productionTime = 0;
		} else if (dayDMY === afterOrderDayDMY) {
			productionTime = 1;
		}

		const obj = { productionDays };

		if (productionTime === 0 || productionTime === 1) {
			// getting a correct name from an array ['today', 'tomorrow']
			obj.text = this.config.data.todayTomorrow[productionTime];
		} else if (date.getTime() >= oneWeekAfterOrderDay.getTime()) {
			/*
			 * if product will be shipped in >= 7 days, we will use the date string
			 * instead of the week day
			 * */
			obj.text = `${`0${date.getDate()}`.slice(-2)}.${`0${date.getMonth() + 1}`.slice(-2)}.${date.getFullYear()}`;
		} else {
			// getting a correct name from an array ['sunday', ..., 'saturday']
			obj.text = this.config.data.daysOfWeek[weekDayCode];
		}

		return obj;
	},

	/*
	 * @method getDayOfShipment
	 * @param type {String} shipment method - standard or express
	 * @param productionDays {Number} days of production of product
	 * @param day {Object} Date type object - day of ordering
	 * @return {Number} day of shipment in ms
	 * */
	getDayOfShipment(type, productionDays, day) {
		const curDay = day || this.getCurrentDate();

		if (this.isHoliday(curDay, this.config.data[type].productionHolidays)) {
			return this.getDayOfShipment(type, productionDays, this.getNextDay(curDay));
		}
		if (this.isWeekend(curDay)) {
			return this.getDayOfShipment(type, productionDays, this.getNextDay(curDay));
		}
		if (this.isBeforeCutoffTime(curDay)) {
			if (productionDays !== 0) {
				productionDays -= 1;

				return this.getDayOfShipment(type, productionDays, this.getNextDay(curDay));
			}

			return curDay.getTime();
		}
		productionDays -= 1;

		return this.getDayOfShipment(type, productionDays, this.getNextDay(curDay));
	},

	/*
	 * return next day after a received one
	 * @method getNextDay
	 * @param day {object} Date type object
	 * */
	getNextDay(day) {
		const nextDay = new Date(day);

		// move timezone
		nextDay.setUTCHours(nextDay.getUTCHours() + this.config.data.cutoffTimezoneOffsetInHours);

		// move to next day 00:00 UTC
		nextDay.setUTCDate(nextDay.getUTCDate() + 1);
		nextDay.setUTCHours(0, 0, 0, 0);

		// move timezone back
		nextDay.setUTCHours(nextDay.getUTCHours() - this.config.data.cutoffTimezoneOffsetInHours, 0, 0, 0);

		return new Date(nextDay);
	},

	/*
	 * setting a Date object with time HH:00:00 where HH is cutoff time
	 * in order to have possibility to compare with a current time of order
	 *
	 * @method getCutoffTime
	 * @param day {String/Object} the date or Date object
	 * @return {Object} Date object with a set cutoff time
	 * */
	getCutoffTime(day) {
		const date = new Date(day || this.config.data.currentDateTime);

		// move timezone
		date.setUTCHours(date.getUTCHours() + this.config.data.cutoffTimezoneOffsetInHours);
		// set hours to cutoffTime
		date.setUTCHours(this.config.data.standard.cutoffTime, 0, 0, 0);
		// move timezone back
		date.setUTCHours(date.getUTCHours() - this.config.data.cutoffTimezoneOffsetInHours);

		return date;
	},

	/*
	 * @method getCurrentDate
	 * @param day {String/Object} an date or Date object
	 * @return {Object} new Date object
	 * */
	getCurrentDate(day) {
		return new Date(day || this.config.data.currentDateTime);
	},

	/*
	 * getting production time from configuration regarding to type of shipment (standard or express)
	 * and taking into account the time of ordering
	 *
	 * @method getProductionTime
	 * @param type {String} standard or express
	 * @return {Number} how many days of production for current type of shipment
	 * */
	getProductionTime(type, day) {
		let beforeAfterSwitch;

		if (
			this.isBeforeCutoffTime(day) ||
			this.isHoliday(day, this.config.data[type].productionHolidays) ||
			this.isWeekend(day)
		) {
			beforeAfterSwitch = 'maxBeforeCutoffTime';
		} else {
			beforeAfterSwitch = 'maxAfterCutoffTime';
		}

		return this.config.data[type][beforeAfterSwitch];
	},

	/*
	 * checking a current day in the array of holidays
	 * if it is inside of array so the current day is a holiday
	 *
	 * @method isHoliday
	 * @param day {Object} Date type object
	 * @param holidays {Array} the list of possible production holidays
	 * @return {Boolean}
	 * */
	isHoliday(day, holidays) {
		const curDay = new Date(day.getTime());

		// move timezone
		curDay.setUTCHours(curDay.getUTCHours() + this.config.data.cutoffTimezoneOffsetInHours);

		const holiday = _.filter(holidays, (holiday) => {
			const dayH = new Date(`${holiday}T00:00:00${this.config.timezoneOffsetString}`);

			// move timezone
			dayH.setUTCHours(dayH.getUTCHours() + this.config.data.cutoffTimezoneOffsetInHours);

			return (
				`${dayH.getUTCDate()}-${dayH.getUTCMonth()}-${dayH.getUTCFullYear()}` ===
				`${curDay.getUTCDate()}-${curDay.getUTCMonth()}-${curDay.getUTCFullYear()}`
			);
		});

		return !!holiday.length;
	},

	/*
	 * checking if the current day of order or a received day is weekend or not
	 *
	 * @method isWeekend
	 * @param day {Object} Data type object
	 * @return {Boolean}
	 * */
	isWeekend(day) {
		let curDay = day || this.getCurrentDate();

		curDay = new Date(curDay.getTime());
		// move timezone
		curDay.setUTCHours(curDay.getUTCHours() + this.config.data.cutoffTimezoneOffsetInHours);

		const weekDay = curDay.getUTCDay();
		const SATURDAY = 6;
		const SUNDAY = 0;

		return weekDay === SATURDAY || weekDay === SUNDAY;
	},

	/*
	 * checking is the current day or the received day before cutoff time or after
	 *
	 * @method isBeforeCutoffTime
	 * @param day {Object} Date type object
	 * @return {Boolean}
	 * */
	isBeforeCutoffTime(day) {
		const curDay = day || this.getCurrentDate();

		return curDay.getTime() <= this.getCutoffTime(curDay).getTime();
	},

	/*
	 * @method calcAdditionalProdDays
	 *
	 * this needs to be kept in sync with Magento:
	 * src/magento/app/code/local/Igniti/Shipping/Model/Carrier/ShippingMethod.php getProductionDelay()
	 * and the constants in
	 * src/magento/app/code/local/Igniti/AMFGateway/Helper/ServiceConfigurationConstants.php
	 *
	 * @param prodOpt {Object} set of product options which could influence on the production time
	 * @return {Number} additional days of production
	 * */

	calcAdditionalProdDays(prodOpt) {
		let itemDelay = 0;
		const specialFormatsRegEx =
			/F430|F431|F432|F433|F434|F435|F436|F437|F102|F174|F270|F275|F276|F285|F295|F298|F299|F073|F091|F193|F660|F662|F700|F710|F712|F715|F716|F390/gi;
		// Keep in sync with Magento ServiceConfigurationConstants::$PHOTOBOOKS_FORMATS
		const individualisableBookRegex =
			/F561|F562|F563|F564|F565|F592|F591|F578|F577|F576|F575|F574|F573|F550|F552|F553|F560|F570|F571|F572|F580|F581|F582|F583|F584|F585/gi;
		const notebooksRegex = /F530|F531|F532|F533/gi;
		// Keep in sync with Magento ServiceConfigurationConstants::$PHOTOBOOK_FORMATS_WITH_LONG_PRODUCTION_DELAY
		const photobookWithLongProductionDelayRegex = /F552|F564|F565|F571|F572/gi;
		const isLightPhotoPrintsRegEx = /F325|F326|F327|F328|F329|F330|F331|F332|F343|F344/gi;
		const isStrongPhotoPrintsRegEx = /F333|F334|F335|F336|F337|F338|F339|F340|F341|F342/gi;
		const isPhotobookOrBookWithoutCustomizablePages =
			prodOpt.format && prodOpt.format.match(individualisableBookRegex);
		const isNotebook = prodOpt.format && prodOpt.format.match(notebooksRegex);
		const isB2BNotebookWithLongProductionDelay =
			(prodOpt.category === 'N8' && prodOpt.format === 'F531') ||
			(prodOpt.category === 'N9' && prodOpt.format === 'F533');
		const isPhotobookWithLongProductionDelay =
			prodOpt.format && prodOpt.format.match(photobookWithLongProductionDelayRegex);
		const formatHasRivets = prodOpt.format && prodOpt.format.match(/F185|F280/gi);
		const printhouseFormat = prodOpt.format && prodOpt.format.match(/F316|F317|F318|F319|F320|F321/gi);
		const isCanvas = prodOpt.paper && prodOpt.paper === 'P50';
		const hasFrame = prodOpt.frame && prodOpt.frame !== 'WF00';

		if (printhouseFormat && !isCanvas) {
			itemDelay += 1;
			if (hasFrame) {
				itemDelay += 2;
			}
		}

		if (isCanvas) {
			itemDelay += 2;
		}

		if (
			(prodOpt.diecut && prodOpt.diecut !== Glossary.NO_DIECUT_SKU) ||
			(prodOpt.tag && prodOpt.tag !== Glossary.NO_TAG_SKU) ||
			(prodOpt.refinement && prodOpt.refinement !== Glossary.NO_REFINEMENT_SKU) ||
			(prodOpt.format && prodOpt.format.match(specialFormatsRegEx)) ||
			(prodOpt.format && prodOpt.format.match(isLightPhotoPrintsRegEx))
		) {
			itemDelay += 1;
		}

		if (prodOpt.format && prodOpt.format === 'F750') {
			itemDelay += 3;
		}

		if (prodOpt.format && prodOpt.format === 'F175') {
			itemDelay += 3;
		}

		if (prodOpt.format && prodOpt.format === 'F650') {
			itemDelay = 2;
		}

		if (prodOpt.format && prodOpt.format === 'F661') {
			itemDelay += 2;
		}

		if (prodOpt.format && prodOpt.format === 'F670') {
			itemDelay += 2;
		}

		if (prodOpt.format && prodOpt.format === 'F360') {
			itemDelay += 2;
		}

		if (prodOpt.format && prodOpt.format.match(isStrongPhotoPrintsRegEx)) {
			itemDelay += 2;
		}

		//MK is a pre-printed baby book
		if (prodOpt.category !== 'MK' && isPhotobookOrBookWithoutCustomizablePages) {
			itemDelay += isPhotobookWithLongProductionDelay ? 4 : 2;
		}

		if (prodOpt.format && isNotebook) {
			itemDelay += 2;
		}

		if (formatHasRivets) {
			itemDelay += 1;
		}

		// V20 needs 2 extra days, that is why here we add +1 and later again +1
		if (prodOpt.refinement && prodOpt.refinement.match(/V20/gi)) {
			itemDelay += 1;
		}

		if (
			(prodOpt.refinement && prodOpt.refinement.match(/V11|V20|V22|V23/gi)) ||
			(prodOpt.format && prodOpt.format.match(/F102/gi))
		) {
			itemDelay += 1;
		}

		// one additional day delay for large orders
		if (prodOpt.quantity >= 2000) {
			itemDelay += 1;
		}

		if (this.config.useIncreasedProductionDelayForBundleProducts && prodOpt.category) {
			if (prodOpt.category.match(/MT/gi) && itemDelay < 1) {
				itemDelay = 1;
			} else if (prodOpt.category.match(/MX|VS|VX|XA|XD/gi) && itemDelay < 2) {
				itemDelay = 2;
			}
		}

		if (isB2BNotebookWithLongProductionDelay && prodOpt.quantity >= 10 && prodOpt.quantity <= 200) {
			itemDelay += 4;
		}

		return itemDelay;
	},
});

export default ShipmentTime;
